<template>
  <span @click.stop="showNextTx = !showNextTx">{{ showNextTx ? nextTx : durationText }} <i class="las la-clock"></i></span>
</template>

<script>

import { DateTime } from 'luxon'

/**
 * Translates seconds into human readable format of seconds, minutes, hours, days, and years
 *
 * @param  {number} seconds The number of seconds to be processed
 * @return {string}         The phrase describing the amount of time
 */
function forHumans (seconds) {
  var levels = [
    [Math.floor(seconds / 31536000), 'years'],
    [Math.floor((seconds % 31536000) / 86400), 'days'],
    [Math.floor(((seconds % 31536000) % 86400) / 3600), 'hours'],
    [Math.floor((((seconds % 31536000) % 86400) % 3600) / 60), 'minutes'],
    [(((seconds % 31536000) % 86400) % 3600) % 60, 'seconds']
  ]
  var returntext = ''

  for (var i = 0, max = levels.length; i < max; i++) {
    if (levels[i][0] === 0) continue
    returntext += ' ' + levels[i][0] + ' ' + (levels[i][0] === 1 ? levels[i][1].substr(0, levels[i][1].length - 1) : levels[i][1])
  };
  return returntext.trim()
}

export default {
  name: 'TimePeriod',
  props: ['duration', 'lastTimestamp'],
  data () {
    return {
      showNextTx: false,
      updateMarker: 1,
      durationText: null
    }
  },
  computed: {
    nextTx () {
      var vm = this

      var datetime = vm.updateMarker ? null : null // READ updateMarker to set reactivity relation on this computed

      if (!vm.duration) {
        return 'Unknown'
      }

      if (vm.lastTimestamp) {
        if (typeof vm.lastTimestamp === 'number') {
          datetime = DateTime.fromMillis(vm.lastTimestamp)
        } else if (typeof vm.lastTimestamp === 'string') {
          datetime = DateTime.fromISO(vm.lastTimestamp)
        }
      }
      if (datetime) {
        return datetime.plus(vm.duration * 1000).toRelative()
      } else {
        return 'Unknown'
      }
    }
  },
  mounted () {
    var vm = this
    if (!vm.duration) {
      vm.durationText = 'Not Set'
    } else {
      vm.durationText = forHumans(vm.duration)
    }
  },
  beforeDestroy () {
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  watch: {
    lastTimestamp: function () {
      var vm = this
      vm.updateMarker = Math.random()
    }
  }
}
</script>
